import Container from "../Container";
import { Brand } from "../../types";

interface BrandsSectionProps {
  brands: Brand[];
}

const BrandsSection = ({ brands }: BrandsSectionProps) => {
  if (!brands || brands.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-gradient-to-r from-slate-50 via-white to-slate-50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900">
      <Container>
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Nuestras <span className="text-brand-gradient">Marcas</span> Aliadas
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Descubre productos de las mejores marcas del mercado
          </p>
          <div className="mt-4 w-24 h-1 bg-brand-gradient rounded-full mx-auto" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-6 md:gap-x-12 lg:gap-x-16">
          {brands.map(
            (brand) =>
              brand.image_url && (
                <div
                  key={brand.id}
                  className="flex-shrink-0 group"
                >
                  <div className="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:scale-105 border border-gray-100 dark:border-gray-700">
                     <img
                       src={brand.image_url}
                       alt={`Logo de ${brand.name}`}
                       className="h-20 w-20 object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                       title={brand.name}
                       loading="lazy"
                       onError={(e) => {
                         // Hide broken images
                         (e.target as HTMLImageElement).style.display = 'none';
                       }}
                     />
                  </div>
                </div>
              ),
          )}
        </div>

        {brands.filter(brand => brand.image_url).length === 0 && (
          <div className="text-center py-12">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
            </div>
            <p className="text-gray-500 dark:text-gray-400">No hay marcas disponibles en este momento</p>
          </div>
        )}
      </Container>
    </section>
  );
};

export default BrandsSection;